import {
    SET_PPA_RATE,
    SET_PPA_ESCALATOR,
    SET_PPA_TERM,
    SET_SHOW_PPA,
    SET_PPA,
} from './constants';

const defaultState = {
    rate: 0,
    term: 20,
    escalator: 2.9,
    showPPA: false,
};

const ppa = (state = defaultState, action) => {
    switch (action.type) {
        case SET_PPA:
            return {
                rate: action.ppa.rate,
                escalator: action.ppa.escalator,
                term: action.ppa.termInYears,
                showPPA: action.ppa.includePpa,
            };
        case SET_PPA_RATE:
            return { ...state, rate: action.rate };

        case SET_PPA_ESCALATOR:
            return { ...state, escalator: action.escalator };

        case SET_PPA_TERM:
            return { ...state, term: action.term };

        case SET_SHOW_PPA:
            return { ...state, showPPA: action.showPPA };

        default:
            return state;
    }
};

export default ppa;



// WEBPACK FOOTER //
// ./src/containers/common/ppa/reducer.js